import { Column, Row, Square } from '@grubhubprod/gh-cookbook-react';
import React from 'react';

export interface IChildAccountRowProps {
  children: React.ReactNode;
}

export function ChildAccountRow({
  children,
}: IChildAccountRowProps): JSX.Element {
  return (
    <Square inset="sm" borderBottom="1px solid" borderColor="lightLine">
      <Row>
        <Column role="cell">{children}</Column>
      </Row>
    </Square>
  );
}
